import React from "react";

const ProductGridSkeleton = ({ count = 8 }) => {
  return (
    <div className="w-full py-16 px-4">

      {/* Heading Skeleton */}
      <div className="flex flex-col items-center animate-pulse">
        <div className="h-8 w-60 bg-gray-300 rounded"></div>

        <div className="w-1/3 border-t border-gray-300 mt-4 mb-10"></div>
      </div>

      {/* GRID */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-sm p-6 animate-pulse"
          >
            {/* IMAGE */}
            <div className="rounded-2xl bg-gray-300 h-[180px] flex justify-center items-center"></div>

            {/* TITLE */}
            <div className="h-5 bg-gray-300 rounded mt-5 w-3/4 mx-auto"></div>

            {/* PRICE */}
            <div className="h-4 bg-gray-300 rounded mt-3 w-1/2 mx-auto"></div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default ProductGridSkeleton;